module.exports = __webpack_public_path__ + "img/googleplay.88690bb8.png";